import React from 'react'

import { Layout, Showcase, Header } from '../../../../components'

import './style.scss'
import data from './data.json'
import changelog from '../../../../data/changelog.json'

export default () => {
  return (
    <>
      <Header
        site={data.site}
        slug={data.slug + '/design/'}
        state="design"
        title={data.title}
      />
      <Layout
        category={data.category}
        changelog={changelog[data.title].changelog}
        description={data.description}
        site={data.site}
        slug={data.slug + '/design/'}
        state="design"
        title={data.title}
        updated={changelog[data.title].lastUpdated}
      >
        ## Values
        <Showcase
          site={data.site}
          switch={false}
          title="Margins"
          text="Margins can be placed horizontally or vertically and should scale appropriately to the size of the component they surround. Use our predefined margin sizes to add consistent space to your designs."
          code={code.top}
        >
          <div class="full-width flex-column">
            <div class="ks-l-margin-bg l-margin-bottom--small">
              <div class="l-margin-top--xxxsmall ks-l-margin">
                <p class="c-text-content">2px - XXX Small</p>
              </div>
            </div>
            <div class="ks-l-margin-bg l-margin-bottom--small">
              <div class="l-margin-top--xxsmall ks-l-margin">
                <p class="c-text-content">4px - XX Small</p>
              </div>
            </div>
            <div class="ks-l-margin-bg l-margin-bottom--small">
              <div class="l-margin-top--xsmall ks-l-margin">
                <p class="c-text-content">8 px - X Small</p>
              </div>
            </div>
            <div class="ks-l-margin-bg l-margin-bottom--small">
              <div class="l-margin-top--small ks-l-margin">
                <p class="c-text-content">12px - Small</p>
              </div>
            </div>
            <div class="ks-l-margin-bg l-margin-bottom--small">
              <div class="l-margin-top--medium ks-l-margin">
                <p class="c-text-content">16px - Medium</p>
              </div>
            </div>
            <div class="ks-l-margin-bg l-margin-bottom--small">
              <div class="l-margin-top--large ks-l-margin">
                <p class="c-text-content">24px - Large</p>
              </div>
            </div>
            <div class="ks-l-margin-bg l-margin-bottom--small">
              <div class="l-margin-top--xlarge ks-l-margin">
                <p class="c-text-content">32px - X Large</p>
              </div>
            </div>
            <div class="ks-l-margin-bg l-margin-bottom--small">
              <div class="l-margin-top--xxlarge ks-l-margin">
                <p class="c-text-content">48px - XX Large</p>
              </div>
            </div>
            <div class="ks-l-margin-bg">
              <div class="l-margin-top--xxxlarge ks-l-margin">
                <p class="c-text-content">64px - XXX Large</p>
              </div>
            </div>
          </div>
        </Showcase>
      </Layout>
    </>
  )
}

export const code = {
  /*
  top: `<div class="l-margin-top--xxsmall"></div>
`,
  bottom: `<div class="l-margin-bottom--xxsmall"></div>
`,
  left: `<div class="l-margin-left--xxsmall"></div>
`,
  right: `<div class="l-margin-right--xxsmall"></div>
`,*/
}
